import { mq, theme } from '@kvdbil/components';
import styled from 'styled-components';
import Routes from './views/Routes';

const Container = styled.div`
  height: auto;
  min-height: 100%;
  max-height: 100%;
  max-width: 1440px;

  display: flex;
  flex-direction: column;
  font-family: 'Open sans', Inter, Helvetica, Arial, sans-serif;

  color-scheme: light dark;
  color: ${theme.colors.text.dark};
  background-color: ${theme.colors.background.light};

  ${mq('laptopL')} {
    margin: auto;
    border-left: 1px solid ${theme.colors.grayscaleToned.light3};
    border-right: 1px solid ${theme.colors.grayscaleToned.light3};
  }
`;

function App() {
  return (
    <Container>
      <Routes />
    </Container>
  );
}

export default App;
